import { fetchGroupMailConfigTags } from '@/services/group-mail-config';

export default {
  namespace: 'LogisticsCountryConfiguration',
  state: {
    groupMailConfigTags: {},
  },

  effects: {
    *getMailConfigTags({ payload, callback }, { call, put }) {
      const response = yield call(fetchGroupMailConfigTags, payload);
      yield put({
        type: 'saveMailConfigTags',
        payload: response,
      });
    },
  },
  reducers: {
    saveMailConfigTags(_, action) {
      return {
        groupMailConfigTags: action.payload ?? {},
      };
    },
  },
};
